import LoanApplication from "./LoanApplication";

export default class State {
  loanApplication: LoanApplication;
  location: Object;

  constructor() {
    this.loanApplication = new LoanApplication();
    this.location = {};
  }
}
